// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tick-or-cross--tick {
  color: green;
}
.tick-or-cross--cross {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/TickOrCross.vue"],"names":[],"mappings":";AAsBA;EACE,YAAY;AACd;AAEA;EACE,UAAU;AACZ","sourcesContent":["<template>\n  <CygnusIcon\n    :name=\"tick ? 'check-circle' : 'x-circle'\"\n    variant=\"solid\"\n    :class=\"tick ? 'tick-or-cross--tick' : 'tick-or-cross--cross'\"\n  />\n</template>\n\n<script setup>\nimport CygnusIcon from '@apexl/icarus-core/src/components/icons/CygnusIcon.vue';\n\nconst props = defineProps(\n    {\n      tick: {\n        type: Boolean,\n        required: true\n      }\n    }\n)\n</script>\n\n<style>\n.tick-or-cross--tick {\n  color: green;\n}\n\n.tick-or-cross--cross {\n  color: red;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
